import { LitElement, html, Splide } from '@hh/global.js'

class HeaderSearchProductCarousel extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.initializeSplide()
  }

  disconnectedCallback() {
    this.splide?.destroy()
    super.disconnectedCallback()
  }

  initializeSplide() {
    const carouselEl = this.querySelector('.splide')
    if (!carouselEl) return


    this.splide = new Splide(carouselEl, {
      arrows: false,
      pagination: false,
      gap: '20px',
      fixedWidth: '80%',
      padding: { left: 14, right: 14 },
      useScroll: true,
      mediaQuery: 'min',
      breakpoints: {
        990: {
          destroy: true,
        },
      },
    })

    const progressBarDesktopEl = this.splide.root.querySelectorAll(
      '.js-splide-progress-bar'
    )

    this.splide.on('ready move', () => {
      setTimeout(() => {
        const end = this.splide.Components.Controller.getEnd() + 1
        const rate = Math.min((this.splide.index + 1) / end, 1)

        progressBarDesktopEl.forEach((bar) => {
          bar.style.width = String(100 * rate) + '%'
        })
      }, 1);
    })

    this.splide.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define(
  'header-search-product-carousel',
  HeaderSearchProductCarousel
)
